// extracted by mini-css-extract-plugin
export default {"box":"Alert_box__dKr1k","selectTitle":"Alert_selectTitle__tDwHk","title":"Alert_title__UHG4q","inputTitle":"Alert_inputTitle__Cbh33"};